import type { NormalizedDefinition } from '@openx/types/gqlTypes';

const US_REGION = 'US';

export const isExplicitNonUsRegion = (normalizedDefinition?: NormalizedDefinition | null): boolean => {
  const groups = normalizedDefinition?.includes?.groups;

  if (!groups?.length) {
    return false;
  }

  return groups.some(group => {
    const region = group.region?.trim();

    return Boolean(region) && region?.toUpperCase() !== US_REGION;
  });
};
